<template>
  <div class="t-divider"/>
</template>

<script>
export default {
  name: 't-divider'
}
</script>

<style lang="scss" scoped>
.t-divider {
  background-color: var(--surface);
  opacity: 0.5;
  height: 1px;
  width: 100%;
}
</style>
